// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"pC-z","expressButtonContainerWithPayPal":"qC-z","expressButton":"rC-z","or":"sC-z"};